"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeoDataProperty = exports.geoDataPropertyDefinition = void 0;
exports.geoDataPropertyDefinition = {
    view: { label: 'Geodata' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'geodata',
    multiple: false,
    name: 'geodata',
};
const isGeoDataProperty = (prop) => {
    return prop.name === exports.geoDataPropertyDefinition.name;
};
exports.isGeoDataProperty = isGeoDataProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvZGF0YS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2dlb2RhdGEucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFO0lBQzFCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxTQUFTO0NBQ2dCLENBQUE7QUFJMUIsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLElBQWtCLEVBQTJCLEVBQUU7SUFDL0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGlDQUF5QixDQUFDLElBQUksQ0FBQTtBQUNyRCxDQUFDLENBQUE7QUFGWSxRQUFBLGlCQUFpQixxQkFFN0IifQ==